import { SingleDatePicker } from 'react-dates';
import React, { useEffect, useState } from 'react';
import { Moment } from 'moment';
import { Icons } from '../icons/icons';
import { format } from 'date-fns';

type Props = {
  name: string;
  format?: string;
  onChange?: (date: string) => void;
};

const defaultFormat = 'yyyy-MM-dd';

export const DatePicker = (props: Props): JSX.Element => {
  const [focused, setFocusState] = useState<boolean>(false);
  const [date, setDate] = useState<Moment | null>(null);

  useEffect(() => {
    if (date) {
      props.onChange?.(format(date.toDate(), props.format || defaultFormat));
    }
  }, [date?.toDate().toISOString()]);

  return (
    <div className="form-control form-control-date">
      <SingleDatePicker
        date={date}
        focused={focused}
        isOutsideRange={(): boolean => false}
        onDateChange={(date: Moment | null): void => setDate(date)}
        onFocusChange={({ focused }): void => setFocusState(focused)}
        numberOfMonths={1}
        id={props.name}
        customInputIcon={<Icons.Calendar />}
        inputIconPosition="before"
        placeholder="Select a Date"
        hideKeyboardShortcutsPanel
        noBorder
      />
    </div>
  );
};
